import { render, staticRenderFns } from "./PowerManage.vue?vue&type=template&id=250fedf9&scoped=true"
import script from "./PowerManage.vue?vue&type=script&lang=js"
export * from "./PowerManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250fedf9",
  null
  
)

export default component.exports